(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define("homepagebundle", ["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["homepagebundle"] = factory(require("React"), require("ReactDOM"));
	else
		root["homepagebundle"] = factory(root["React"], root["ReactDOM"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__1024__, __WEBPACK_EXTERNAL_MODULE__314__) => {
return 